<template>
    <div id="fahrzeugFach">
        <h1>{{ fahrzeug.name }} - {{ fach.name }}</h1>
        
        <div class="gerate-list">
            <GeraetInFach 
                v-for="geraet in this.geraete" 
                :key="geraet.geraetID" 
                :geraet="geraet" 
                :fahrzeug="this.$props.fahrzeug"
                :fach="this.$props.fach"
                @update-selection="updateSelectedGeraete">
            </GeraetInFach>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import axios from 'axios';
import GeraetInFach from '@/components/GeraetInFach.vue';

export default {
    name: 'MTA2',
    components: {
        GeraetInFach
    },
    props: {
        fahrzeug: Object,
        fach: Object
    },
    data() {
        return {
            geraete: []
        }
    },
    methods: {
        async getGeraete() {
            try {
                const response = await axios.get(
                'https://feuerwehr-server.org:5000/geraet'
                );

                console.log(response.data);
                response.data.sort((a, b) => a.name.localeCompare(b.name));
                return response.data;
            } catch (err) {
                console.log(err);
                return false;
            }
        },
    },
    async created(){
        this.geraete = await this.getGeraete();
    },
}
</script>

<style lang="scss">
#fahrzeugFach {
    padding: 20px;
    background-color: rgb(236, 236, 236);
    margin-bottom: 4.5rem;
    margin-top: 3.6rem;

    h1 {
        text-align: center;
        margin-bottom: 20px;
    }

    .gerate-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 10px;
    }

    /* Responsive design: 2 Spalten für Tablets, 1 Spalte für Smartphones */
    @media (max-width: 768px) {
        .gerate-list {
            flex-direction: column;
        }
    }
}
</style>
